export enum Layout {
    Grid,
    List
}